import { put, call, delay } from 'redux-saga/effects';
import { overtimeConstants } from './OvertimeConstants';
import { getCallsheet, addOTShiftAPI } from './index';
import { getOTSkillsData } from '../OT-Comp/index';
import * as actions from '../OT-Comp/OvertimeAction';

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;

export function* getOvertimeData(action) {
    try {
        yield put({ type: overtimeConstants.SHOW_OVERTIME_LOADER, data: true });
        const response = yield call(getCallsheet, action.params);
        
        yield put({ 
            type: overtimeConstants.GET_OVERTIME_DATA_SUCCESS, 
            data: response.data 
        });
        
        yield put({ type: overtimeConstants.SHOW_OVERTIME_LOADER, data: false });
    } catch (error) {
        yield put({ 
            type: overtimeConstants.GET_OVERTIME_DATA_FAILED, 
            data: error.message || 'Failed to fetch overtime data' 
        });
        yield put({ type: overtimeConstants.SHOW_OVERTIME_LOADER, data: false });
    }
}

export function* confirmOvertimeDecision(action) {
    const { employeeId, shiftName, decision, shiftData } = action;
    
    try {
        yield put({ type: overtimeConstants.SHOW_OVERTIME_LOADER, data: true });

        // If decision is ACCEPT (Assign), make the addOTShift API call
        if (decision?.toUpperCase() === 'ACCEPT') {
            const requestBody = {
                otShiftKey: {
                    callSheetId: shiftData?.callSheetId || '',
                    aaID: employeeId
                },
                shiftStart: shiftData?.shiftStart || '',
                shiftEnd: shiftData?.shiftEnd || '',
                otReason: shiftData?.otReason || '',
                unpaidLunch: shiftData?.unpaidLunch || 0,
                shiftLocation: shiftData?.shiftLocation || '',
                otResponse: shiftData?.otResponse || '',
                otOverlap: shiftData?.otOverlap || 0,
                adminID: shiftData?.adminID || '',
                violationApprover: shiftData?.violationApprover || '',
                resolutionNotes: shiftData?.resolutionNotes || '',
                requestTimestamp: new Date().toISOString(),
                station: shiftData?.station || '',
                schedBidGroup: shiftData?.schedBidGroup || '',
                otGroup: shiftData?.otGroup || '',
                wbstatus: shiftData?.wbstatus || '',
                wbrequestID: shiftData?.wbrequestID || '',
                wbrequestTime: shiftData?.wbrequestTime || '',
                wbtransID: shiftData?.wbtransID || '',
                wbprevTransID: shiftData?.wbprevTransID || ''
            };

            const response = yield call(addOTShiftAPI, requestBody);

            if (response?.data?.statusCode === 'SUCCESS' || response?.data?.result?.status === 'SUCCESS') {
                yield put({
                    type: overtimeConstants.ADD_OT_SHIFT_SUCCESS,
                    employeeId,
                    shiftName,
                    data: response.data
                });

                yield put({
                    type: overtimeConstants.CONFIRM_DECISION_SUCCESS,
                    employeeId,
                    shiftName
                });
            } else {
                throw new Error(response?.data?.message || 'Failed to assign shift. Please try again.');
            }
        } else {
            // For REFUSED or other decisions, just update the local state
            yield put({
                type: overtimeConstants.CONFIRM_DECISION_SUCCESS,
                employeeId,
                shiftName
            });
        }

        yield put({ type: overtimeConstants.SHOW_OVERTIME_LOADER, data: false });
    } catch (error) {
        yield put({
            type: overtimeConstants.CONFIRM_DECISION_FAILED,
            data: error.message || 'Failed to confirm decision. Please try again.'
        });
        
        yield put({
            type: overtimeConstants.ADD_OT_SHIFT_FAILED,
            employeeId,
            shiftName,
            data: error.message || 'Failed to assign shift. Please try again.'
        });
        
        yield put({ type: overtimeConstants.SHOW_OVERTIME_LOADER, data: false });
    }
}

export function* getOTSkillsDataSaga(data) {
    for(let i = 0; i < MAX_RETRIES; i++) {
        try {
            const response = yield call(
                getOTSkillsData,
                data.params,
            )
            
            if (response?.status === 200) {
                yield put(actions.getOTSkillsDataSuccess(true))
                const skillsData = response.data?.otskills || response.data?.skills || response.data || [];
                yield put(actions.getOTSkillsResponse(skillsData))
                return; // Success - exit the function
            } else {
                console.log("ERROR: " + response?.status);
                if (i === MAX_RETRIES - 1) {
                    yield put(actions.getOTSkillsDataSuccess(false))
                } else {
                    yield delay(RETRY_DELAY);
                }
            }
        }
        catch (error) {
            console.log("ERROR: " + error);
            if (i === MAX_RETRIES - 1) {
                // Last retry attempt failed
                yield put(actions.getOTSkillsDataSuccess(false))
            } else {
                yield delay(RETRY_DELAY);
            }
        }
    }
}
